// React
import React from "react";

// Helper Imports
import { formatDate } from "../../../../../Helpers/formatters";

// MUI Imports
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const formatThreshold = (count, threshold) => {
 return count + ' out of ' + threshold;
};

const getThresholdStatus = (count, threshold) => {
  if(count === undefined || threshold === undefined)
  {
    return null;
  } else if(count > threshold)
  {
    return "exceedsThreshold";
  } else {
    return "withinThreshold"
  }
};

const CustomerReportDownloadsBody = ({ reportDownloads }) => {
  return (
    <TableBody>
      <TableRow>
        <TableCell className="tableCell" align="center">
          {formatDate(reportDownloads.billingStartDate)}
        </TableCell>
        <TableCell className="tableCell" align="center">
          {formatDate(reportDownloads.billingEndDate)}
        </TableCell>
        <TableCell className="tableCell" align="center">
          <span className={getThresholdStatus(reportDownloads.peopleReportCount, reportDownloads.peopleReportThreshold)}>
            {formatThreshold(reportDownloads.peopleReportCount, reportDownloads.peopleReportThreshold)}
          </span>
        </TableCell>
        <TableCell className="tableCell" align="center">
          <span className={getThresholdStatus(reportDownloads.propertyReportCount, reportDownloads.propertyReportThreshold)}>
            {formatThreshold(reportDownloads.propertyReportCount, reportDownloads.propertyReportThreshold)}
          </span>
        </TableCell>
        <TableCell className="tableCell" align="center">
          <span className={getThresholdStatus(reportDownloads.phoneReportCount, reportDownloads.phoneReportThreshold)}>
            {formatThreshold(reportDownloads.phoneReportCount, reportDownloads.phoneReportThreshold)}
          </span>
        </TableCell>
        <TableCell className="tableCell" align="center">
          <span className={getThresholdStatus(reportDownloads.socialReportCount, reportDownloads.socialReportThreshold)}>
            {formatThreshold(reportDownloads.socialReportCount, reportDownloads.socialReportThreshold)}
          </span>
        </TableCell>
        <TableCell className="tableCell" align="center">
          <span className={getThresholdStatus(reportDownloads.autoReportCount, reportDownloads.autoReportThreshold)}>
            {formatThreshold(reportDownloads.autoReportCount, reportDownloads.autoReportThreshold)}
          </span>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

export default CustomerReportDownloadsBody;
